import React, { useState } from "react";
import InformationIcon from "shared/ui/icons/Information";
import Wrench from "shared/ui/icons/selfAssembly/Wrench";
import Text from "shared/ui/typography/Text";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import MonthlyPaymentModal from "widgets/shared/montly-payment-modal";
import { DoorOptionsFooterProps } from "./DoorOptionsFooterMobile";

export const DoorOptionsFooterNormal: React.FC<DoorOptionsFooterProps> = ({
  selectedDoor,
  monthlyPayment,
  addToCart,
  getConfigurationPrice,
  isSelfAssembly = false,
}) => {
  const [isMonthlyPaymentModalOpened, setIsMonthlyPaymentModalOpened] =
    useState(false);

  if (!selectedDoor) return null;

  const showMonthlyPayment = monthlyPayment && monthlyPayment > 0;

  return (
    <>
      <MonthlyPaymentModal
        isOpen={isMonthlyPaymentModalOpened}
        setIsOpen={setIsMonthlyPaymentModalOpened}
      />
      <div className="gg-grid gg-h-[104px] gg-w-full gg-border-t-2 gg-border-gray-200 gg-bg-gray-50">
        {/* First row */}
        <div className="gg-flex gg-w-full gg-flex-row gg-justify-between gg-px-8 xl:gg-px-12 2xl:gg-px-16">
          {/* LEFT SIDE */}
          <div className="gg-grid gg-items-start gg-py-4">
            {/* Selected standard product name */}
            <p className="gg-self-center gg-pr-2 gg-text-lg gg-font-bold gg-text-slate-800 2xl:gg-text-xl">
              {selectedDoor.name}
            </p>

            {isSelfAssembly && (
              <Text className="gg-flex gg-items-center gg-gap-x-2.5 gg-text-sm gg-text-purple-300">
                <Wrench />
                Zelfmontage
              </Text>
            )}
          </div>
          {/* LEFT SIDE END */}

          {/* RIGHT SIDE */}
          <div className="gg-flex gg-items-center gg-space-x-5 xl:gg-space-x-8">
            <div className="gg-flex gg-flex-col gg-space-y-1">
              <div className="gg-flex gg-flex-row">
                {/* Price formatted output */}
                <div className="gg-flex gg-items-center gg-gap-x-2">
                  <p className="gg-self-center gg-text-lg gg-font-bold gg-text-slate-800">
                    {getFormattedPrice(getConfigurationPrice())}
                  </p>
                  {isSelfAssembly && (
                    <p className="gg-relative gg-self-center gg-text-sm gg-font-bold gg-text-grey-100">
                      {getFormattedPrice(
                        getConfigurationPrice() +
                          (selectedDoor.selfAssemblyDiscount || 0),
                      )}
                      <span className="gg-absolute gg-left-0 gg-top-1 gg-h-px gg-w-full gg-origin-left gg-rotate-12 gg-bg-grey-100"></span>
                    </p>
                  )}
                </div>
              </div>

              {isSelfAssembly && (
                <span className="gg-text-xs">zelfmontage prijs</span>
              )}

              <div className="gg-flex gg-items-center gg-space-x-0.5">
                {/* Monthly payment */}
                <p
                  className={`gg-w-24 gg-whitespace-nowrap gg-text-xs gg-leading-5 gg-text-dark-blue/80 gg-transition-opacity gg-delay-150 gg-duration-300 gg-ease-in-out ${
                    showMonthlyPayment ? "gg-opacity-100" : "gg-opacity-0"
                  }`}
                >
                  Of v.a. €{monthlyPayment} p/m
                </p>
                {/* Monthly payment info icon */}
                <button
                  type="button"
                  aria-label="Meer informatie over betalen per maand"
                  disabled={!showMonthlyPayment}
                  aria-hidden={!showMonthlyPayment}
                  className={`gg-pl-0.5 gg-transition-opacity gg-delay-150 gg-duration-300 gg-ease-in-out ${
                    showMonthlyPayment ? "gg-opacity-100" : "gg-opacity-0"
                  }`}
                  onClick={() =>
                    setIsMonthlyPaymentModalOpened(!isMonthlyPaymentModalOpened)
                  }
                >
                  <InformationIcon
                    className="gg-fill-gray-500 hover:gg-fill-gray-900"
                    width={28}
                    height={28}
                  />
                </button>
              </div>
            </div>
            {/* Buttons */}
            <div className="gg-flex gg-items-center gg-space-x-2.5 xl:gg-space-x-3">
              {/* add to cart */}

              {/* <button
                type="button"
                className="gg-rounded-sm gg-justify-center gg-px-4 gg-py-3.5 xl:gg-px-7 xl:gg-py-4 2xl:gg-px-9 gg-text-base gg-font-bold hover:gg-text-zinc-900 hover:gg-bg-gray-200   gg-bg-gray-200/80 gg-text-zinc-500"
              >
                Maak ontwerp
              </button> */}
              <button
                type="button"
                onClick={() => addToCart()}
                data-testid="add-to-cart"
                className="gg-justify-center gg-rounded-sm gg-bg-yellow-300 gg-px-4 gg-py-3.5 gg-text-base gg-font-bold gg-text-dark-blue hover:gg-bg-yellow-400 hover:gg-text-zinc-900 xl:gg-px-7 xl:gg-py-4 2xl:gg-px-9"
              >
                In winkelmand
              </button>
            </div>
          </div>
        </div>
        {/* First row end */}
      </div>
    </>
  );
};
